import React from "react";
import TextField from "@material-ui/core/TextField";

type Props = {
  value: Record<string, unknown>;
  onChange: (newValue: Record<string, unknown>) => void;
};

export default function TestValue({value, onChange}: Props) {
  const {required = "", optional = ""} = value;

  const handleChange = (field: "required" | "optional") => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onChange({
      required: field === "required" ? event.target.value : value.required,
      optional: field === "optional" ? event.target.value : value.optional,
    });
  };

  return (
    <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
      <TextField
        value={required}
        onChange={handleChange("required")}
        label="Required"
        variant="outlined"
      />
      <TextField
        value={optional}
        onChange={handleChange("optional")}
        label="Optional"
        variant="outlined"
      />
    </div>
  );
}
